import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  ViewEncapsulation, AfterViewInit,
} from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Transaction, Payment } from '../../models';
import { TokenServiceService } from '../../services/token-service.service';
import { AlertService } from '../../services/alert.service';
import { DepositComponent } from '../deposit/deposit.component';
import { EfectivoComponent } from '../efectivo/efectivo.component';
import { TransferInstructionsComponent } from '../transfer-instructions/transfer-instructions.component';
import { TransferComponent } from '../transfer/transfer.component';
import { CONCEPTS } from '../../core/constants/Concepts';
import { CURRENCIES } from '../../../assets/strings/translations';
import { BANNER_MESSAGES } from 'src/app/core/constants/General-constants';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { GeneralTool } from '../split-payment/tools/general-tools';


@Component({
  selector: 'app-cash',
  templateUrl: './cash.component.html',
  styleUrls: ['./cash.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CashComponent implements OnInit, AfterViewInit {
  @Input() info: Payment;
  @Input() country: string;
  @Input() visibleReturnPayMethods: boolean;

  user;
  loading: boolean;
  transaction: Transaction;
  orderID: string;
  template: string;
  showSpecial: boolean;
  currentConcept: any;
  valid: boolean;
  valuesToCopy = 0;
  isCashRobot = false;

  readonly CONCEPTS = CONCEPTS;

  @ViewChild(DepositComponent) deposit: DepositComponent;
  @ViewChild(TransferComponent) transfer: TransferComponent;
  @ViewChild(EfectivoComponent) efectivo: EfectivoComponent;
  @ViewChild(TransferInstructionsComponent) trasferencia: TransferInstructionsComponent;
  @ViewChild('printCash') elem: ElementRef;
  @Output() CASH = new EventEmitter();
  @Output() transferNetworkCode: Number;
  formPrivacyValid: boolean = false;
  cashBannerMessage: string = BANNER_MESSAGES.CASH_RECOMMENDATION;
  depositBannerMessage: string = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
  bannerText: string;
  merchantHasWallet: boolean;
  private flag = 'recommendationBannersForPaymentMethodsFF';
  private platform = 'payvalida';
  bannerRecommedationFF: boolean = false;

  private parameter = 'bannerRecommedationUiFixFF';
  private flag2 = 'bannerRecommedationUiFixFF';
  private platform2 = 'payvalida';
  bannerRecommedationUiFixFF: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly alertService: AlertService,
    private readonly tokenServiceService: TokenServiceService,
    private readonly paymentMethodsService: PaymentMethodsService,
    private featureFlagService: PayvalidaFeatureFlagService
  ) { }

  ngOnInit() {
    this.onActivate();

    this.featureFlagService
      .getFeatureFlagValue(`${this.info.template}_banner`, this.flag, this.platform)
      .subscribe((response: boolean) => {
        this.bannerRecommedationFF = response;
      });

    this.featureFlagService
      .getFeatureFlagValue(this.parameter, this.flag2, this.platform2)
      .subscribe((response: boolean) => {
        this.bannerRecommedationUiFixFF = response;
      });

    const token = this.tokenServiceService.getToken();

    this.paymentMethodsService.paymentMethods(token).subscribe((data: any) => {
      const merchantHasWallet = GeneralTool.checkMerchantHasWallet(data);

      if (merchantHasWallet) {
        this.merchantHasWallet = true;
      }
    });

    this.orderID = this.authService.getOrderID();
    this.template = this.info.template;
    this.isCashRobot = this.info.code === 330;
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    this.transferNetworkCode = this.info.code;

    if (this.info.concept.length <= 1) {
      this.currentConcept = this.info.concept[0];

      if (this.info.template === 'cash') {
        this.user = 'Efectivo';
      } else if (this.info.category !== '5') {
        this.user = 'Transferencia';
      } else {
        this.user = 'Depósito';
      }
    } else if (this.transaction.ORDER_CURRENCY === CURRENCIES.CRC) {
      this.currentConcept = this.info.concept[0];

      if (this.info.category === '5') {
        this.user = CONCEPTS.DEPOSIT;
      } else if (this.info.category === '7') {
        this.user = CONCEPTS.TRANSFER_SINPE;
      }
    }

    this.user === CONCEPTS.CASH ||
      this.info.concept[0].type === CONCEPTS.CASH_IN_AGENT
      ? (this.bannerText = BANNER_MESSAGES.CASH_RECOMMENDATION)
      : (this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION);
  }

  changeRobotMethod() {
    this.isCashRobot = !this.isCashRobot;
    this.setUser(this.user);
  }

  ngAfterViewInit() {
    this.setUser(this.user);
  }

  finalize() {
    if (this.user === CONCEPTS.DEPOSIT) {
      this.deposit.sendEmail();
    } else if (this.user === CONCEPTS.TRANSFER_SINPE) {
      this.transfer.sendEmail();
    } else {
      this.alertService.showPopup('¡Gracias!',
        `Recuerda que tienes hasta ${this.transaction.EXPIRATION} para realizar tu pago`, 'success', 'Aceptar');
    }
  }

  changeMethod() {
    this.CASH.emit();
    if (this.user !== '' && this.info.concept.length > 1) {
      this.valid = false;
      this.user = '';
    } else {
      this.CASH.emit();
    }
  }

  setUser(u: string) {
    this.user = u;
    setTimeout(() => {
      if (u === CONCEPTS.DEPOSIT) {
        if (this.deposit != null) {
          this.deposit.emailForm.valueChanges.subscribe(() => this.checkForms());
        }
      } else if (u === CONCEPTS.CASH) {
        this.valuesToCopy = this.efectivo.copiesComponents.length;
        this.efectivo.copiesComponents.forEach(c => c.onCopy.subscribe(() => {
          this.valuesToCopy--;
          this.checkForms();
        }));
      } else if (u === CONCEPTS.TRANSFER) {
        this.valuesToCopy = this.trasferencia.copiesComponents.length;
        this.trasferencia.copiesComponents.forEach(c => c.onCopy.subscribe(() => {
          this.valuesToCopy--;
          this.checkForms();
        }));
      } else if (u === CONCEPTS.TRANSFER_SINPE) {
        this.transfer.emailForm.valueChanges.subscribe(v => this.checkForms());
        this.valuesToCopy = this.transfer.copiesComponents.length;
        this.transfer.copiesComponents.forEach(c => c.onCopy.subscribe(() => {
          this.valuesToCopy--;
          this.checkForms();
        }));
      }
    }, 1);
  }

  /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
  */
  formPrivacyUpdate = (valid: boolean) => {
    this.formPrivacyValid = valid;
  }
  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
  */
  completedForms = (): boolean => {
    return this.formPrivacyValid && this.deposit.emailForm.valid;
  }

  checkForms() {
    if (this.user === CONCEPTS.DEPOSIT) {
      this.valid = this.deposit.emailForm.valid;
    } else if (this.user === CONCEPTS.TRANSFER_SINPE) {
      this.valid = this.transfer.emailForm.valid;
    } else {
      this.valid = this.valuesToCopy <= 0;
    }
  }

  onActivate() {
    window.scroll(0, 0);
  }
}
